import React from 'react';

class Home extends React.Component {
    static displayName = Home.name;

    render() {
        return (
            <React.Fragment>
                <h2 className={'content-block'}>Home</h2>

                <p>Benvenuto in License Manager! </p>

                <p>Qui potrai gestire tutti gli aspetti delle licenze come ad esempio:</p>
                <ul>
                    <li><strong>Creazione</strong>;</li>
                    <li><strong>Modifica</strong>: permette di modificare i dati di dettaglio di una licenza;</li>
                    <li><strong>Scadenza</strong>: permette di modificare la data di scadenza, scegliendone una nuova o indicando il numero di mesi di cui la si vuole estendere;</li>
                    <li><strong>Stato</strong>: permette di bloccare o sbloccare una licenza del <em>Software Gestionale L@ZIENDALE</em> ;</li>
                    <li><strong>Disassocia</strong>: permette di disassociare una licenza dalla sua componente Hardware, permettendo cosi la reinstallazione del <em>Software Gestionale L@ZIENDALE</em> in una nuova macchina;</li>
                    <li><strong>Moduli</strong>: permette di selezionare quali moduli associare ad una licenza;</li>
                    <li><strong>Statistiche</strong>: per avere un quadro riassuntivo delle proprie licenze;</li>
                    {/*
                    <li><strong>Log accessi</strong>: in cui &egrave; possibile monitorare gli accessi al <em>Software Gestionale Vision</em> ;</li>
                    <li><strong>Log licenze</strong>: in cui &egrave; possibile tracciare le operazioni di modifica effettuate per le varie licenze;</li>
                    */}
                </ul>
            </React.Fragment>
        );


    }
}


export default Home;